import { PropertyInvoicesContainer } from 'components/modules/Properties/Details/AllInvoices';

export const PropertyInvoices = () => <PropertyInvoicesContainer />;
